module.exports = __webpack_public_path__ + "img/best_1.654f74db.svg";